"use client";

import ResponsiveWrapper from "@/components/layout/ResponsiveWrapper";
import ZStack from "@/components/layout/ZStack";
import Image from "@/components/media/Image";
import { cn } from "@/lib/utils";
import { withRef } from "@/lib/with-ref";
import React from "react";
import type { BackgroundImageElement, BackgroundImageProps } from "./types";

const BackgroundImage = withRef<BackgroundImageElement, BackgroundImageProps>(
  (
    {
      src,
      alt,
      width,
      height,
      fill = true,
      sizes = "100vw",
      overlay = "",
      responsive = {},
      foreground = "",
      showImage = true,
      children,
      className = "",
      imageClassName = "",
      style = {},
      ...props
    },
    ref,
  ) => {
    return (
      <ResponsiveWrapper responsive={responsive}>
        <ZStack
          id="background-img"
          ref={ref}
          className={cn("relative w-full h-full", className)}
          style={style}
        >
          {/* Background Image */}
          {showImage && (
            <ZStack.Child zIndex={0}>
              <Image
                src={src}
                alt={alt}
                width={width}
                height={height}
                fill={fill}
                sizes={sizes}
                className={imageClassName}
                {...props}
              />
            </ZStack.Child>
          )}

          {/* Optional Overlay */}
          {overlay && (
            <ZStack.Child
              id="img-overlay"
              zIndex={5}
              className={cn("absolute inset-0", overlay)}
            />
          )}

          {/* Foreground Content */}
          <ZStack.Child
            id="img-foreground-content"
            zIndex={10}
            className={cn("relative h-full w-full", foreground)}
          >
            {children}
          </ZStack.Child>
        </ZStack>
      </ResponsiveWrapper>
    );
  },
);

BackgroundImage.displayName = "BackgroundImage";

export default React.memo(BackgroundImage);
